__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalSegmentation";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(639).then(() => (() => (__webpack_require__(639))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("moment-timezone", "0.5.47", () => (Promise.all([__webpack_require__.e(743), __webpack_require__.e(314)]).then(() => (() => (__webpack_require__(84743))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(29), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(95093))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(654)]).then(() => (() => (__webpack_require__(71468))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__(14644))))));
			initExternal(52833);
			initExternal(41441);
			initExternal(38359);
			initExternal(77672);
			initExternal(87883);
			initExternal(38230);
			initExternal(15822);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};